var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnxiety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0843 15.3674H12.085C12.085 15.3674 12.0855 15.3674 12.0857 15.3674C13.8853 15.367 15.344 13.9082 15.344 12.1085V10.2618C15.344 8.46193 13.8849 7.00291 12.0851 7.00291C10.2852 7.00291 8.82617 8.46198 8.82617 10.2618V12.1085C8.82608 13.9082 10.2848 15.367 12.0843 15.3674Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4173 15.3703C14.5699 16.2358 13.3892 16.7739 12.0851 16.7739C10.781 16.7739 9.60037 16.2358 8.75295 15.3703C7.51202 15.4306 6.52441 16.4557 6.52441 17.7116V24H17.6458V17.7116C17.6458 16.4557 16.6582 15.4307 15.4173 15.3703V15.3703Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.296 4.73208L12.5823 5.30097L13.6686 2.84482L12.2757 1.97616L12.8883 0.557496L11.5969 0L10.5049 2.52943L11.8885 3.39228L11.296 4.73208Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1442 4.22855L19.6254 2.92124L17.0645 3.93764L17.4328 5.52611L16.0664 6.05454L16.5737 7.36635L19.0787 6.39768L18.7079 4.79861L20.1442 4.22855Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30058 6.66225L7.33191 4.15734L5.73284 4.52805L5.16278 3.09176L3.85547 3.61062L4.87177 6.17147L6.46034 5.80319L6.98877 7.16953L8.30058 6.66225Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnxiety);
export default __webpack_public_path__ + "static/media/anxiety.27a730742bf8e776fb30a30e2b4a41ad.svg";
export { ForwardRef as ReactComponent };